import { createSlice } from '@reduxjs/toolkit';

const initialState: { user: any } = { user: null };

const estudianteSlice = createSlice({
	name: 'estudiante',
	initialState,
	reducers: {
		updateEstudiante: (state, action) => {
			return { ...state, ...action.payload };
		},
		logoutEstudiante: (state, action) => {
			return {
				...state,
				user: {}
			};
		},
		removeEstudiante: (state, action) => {
			return {
				...state,
				user: {}
			};
		}
	}
});

export const { updateEstudiante, logoutEstudiante, removeEstudiante } = estudianteSlice.actions;
export default estudianteSlice.reducer;
